import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MipdWardService {
  mipdWard: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mipd_ward/list/?';
  private ListRecordByUnit = webapi + 'mipd_ward/listByUnitId/?';
  private DeListRecord = webapi + 'mipd_ward/deactivated_list/?';
  private AddRecord = webapi + 'mipd_ward/create';
  private EditRecord = webapi + 'mipd_ward/update';
  private GetRecord = webapi + 'mipd_ward/byid/';
  private DeleteRecord = webapi + 'mipd_ward/delete/';
  private ReActiveRecord = webapi + 'mipd_ward/reActive/';
  private GetRecordbyclass = webapi + 'mipd_ward/byclassidid/';
  private GetRecordbyunit = webapi + 'mipd_ward/byunitid/';
  private GetWardByFloorId = webapi + 'mipd_ward/byfloorId/';
  private GetRecordbyunitclass = webapi + 'mipd_ward/byclassidunitid/';
  private GetWardByFloorIdAndUnitId = webapi + 'mipd_ward/getWardByFloorIdAndUnitIdd/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByUniTd(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
    return this.http.get(this.ListRecordByUnit + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getAllRecordbyclassService(id: any): Promise<any> {
    return this.http.get(this.GetRecordbyclass + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordbyunitService(id: any) {
    return this.http.get(this.GetRecordbyunit + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordbyunitancclassService(classid: any, unitid: any) {
    return this.http.get(this.GetRecordbyunitclass + classid + '/' + unitid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getWardByFloorIdService(floorId: any) {
    return this.http.get(this.GetWardByFloorId + floorId)
      .toPromise()
      .then(respose => respose.json())
      .catch(this.handleError);
  }

  getWardByFloorIdAndUnitId(floorId: any, unitId: any) {
    return this.http.get(this.GetWardByFloorIdAndUnitId + floorId + '/' + unitId)
      .toPromise()
      .then(respose => respose.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mipd-ward/mipd-ward.service.ts